import { getAccessTokenOrCookie } from '../common/atoms/Login/login.util';
import { store } from '../redux/store';
import { setMaintenanceMode } from '../redux/slices/appState';

const defaultHttpConfig = {
  cachePolicy: 'no-cache',
  interceptors: {
    request: ({ options }) => {
      const accessToken = getAccessTokenOrCookie();
      // eslint-disable-next-line no-param-reassign
      options.headers = {
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      // eslint-disable-next-line no-param-reassign
      options.cachePolicy = 'no-cache';
      return options;
    },
    response: async ({ response }) => {
      // Handle 503 Maintenance Mode responses
      if (response.status === 503) {
        const clonedResponse = response.clone();
        try {
          const body = await clonedResponse.json();
          if (body?.code === 'MAINTENANCE_MODE_ENABLED') {
            console.warn('Maintenance mode detected via use-http 503 + code, setting global state.');
            store.dispatch(setMaintenanceMode(true));

            throw new Error('MAINTENANCE_HANDLED');
          }
        } catch (e) {
          // Handle cases where the body isn't JSON or other errors during check
          if (e.message !== 'MAINTENANCE_HANDLED') {
            console.error('Error checking 503 response body in interceptor:', e);
          } else {
            // Rethrow the specific maintenance error if that's what was caught
            throw e;
          }
        }
      }

      // For all other responses (including 503s without the specific code, or other errors),
      // return the original response object so use-http can process it normally.
      return response;
    },
  },
};

export default defaultHttpConfig;
